// extracted by mini-css-extract-plugin
export default {"haibao":"index_haibao_tlCbJ","close":"index_close_wwDLd","tip":"index_tip_LfWvC"};